export default "__VITE_ASSET___sJe8TrI__"